import React, { Component } from 'react';
import {MasterLayout} from 'layout';
import DataTable from 'components/data-table';
import { Link, browserHistory } from 'react-router';
import ThongTinChungView from './ThongTinChungView.jsx';
import { header } from 'constants/table';
import { RowItemDanhMucCuocThanhTra } from 'modules/thanh-tra-trung/datatable';
import {ContainerFileDinhKem} from 'components/upload';
import {ThanhTra} from 'api';
import { get } from 'lodash';


export default class KeHoachThanhTraDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  onClickClose() {
    browserHistory.goBack();
  }

  componentDidMount() {
    if (this.props.params && this.props.params.id) {
      this.getDetailKHTT(this.props.params.id);
    }
  }


  getDetailKHTT(idKH) {
    ThanhTra.actions.getKeHoachThanhTraDetail.request({id: idKH}).then(res => {
      if (res.data) {
        let state = this.state;
        state.detail = res.data;
        state.activeTaoCuocThanhTra = res.data.activeTaoCuocThanhTra;
        state.sendToThanhTra = res.data.saveTamKeHoachTT;
        state.enableEdit = (res.data.cuocThanhTras.length == 0);
        res.data.cuocThanhTras.map(item2 => {
          if (item2.tienDoThanhTraInfo == null) {
            state.enableEdit = true;
          }
        });
        this.setState({...state});
      }
    });
  }


  render() {
    const type = get(this.state.detail, 'loaiKeHoach.value') === 'KIEM_TRA' ? 'kiểm tra' : 'thanh tra';
    const dataCuocThanhTra = this.state.detail && this.state.detail.cuocThanhTras
    const namThanhTra = this.state.detail && this.state.detail.namThanhTra
    const dataTepDinhKem = this.state.detail && this.state.detail.taiLieuVanThus;
    return (
      <MasterLayout routerName={this.props.route.name}>
        <div className="center wrap-block">
          <div className="back-foward">
            <Link onClick={ this.onClickClose.bind(this, 'close') } title="">Về trang trước</Link>
          </div>
          <div className="heading">
            <h2 className="heading-title icon-add">
              {`Kế hoạch ${type} năm ${namThanhTra}`}
            </h2>
          </div>
          <div className="page-wrapper">
            <ThongTinChungView details={this.state.detail} type={type} />
          </div>
          <div className="page-wrapper">
          <div className="title">
            <div className="rows">
              <div className="col">
                <h3 className="mb15 tt-title">2. Danh mục {type}</h3>
              </div>
            </div>
          </div>
          <div className='ttt-wrapper-table'>
            <DataTable
              header={header.thanhTraTrung.KHTTD}
              dataList={dataCuocThanhTra}
              hideButtonExport
              hidePagination
              parent={this}
              tableLoading={this.state.tableLoading}>
              <RowItemDanhMucCuocThanhTra/>
            </DataTable>
          </div>
          </div>
          <div className="page-wrapper">
            <div className="items-form mb20">
              <ContainerFileDinhKem disableTopLine labelClass="tt-title" label="3. Danh sách văn bản xử lý" hideDescription disableAttachFile dataShow={dataTepDinhKem}/>
            </div>
          </div>
          <div className="box-bottom ttt-bottom">
            <Link className="btn-action btn-close action-todo" role="button" onClick={this.onClickClose.bind(this)}><span>Đóng</span></Link>
          </div>
        </div>
      </MasterLayout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra-trung/KeHoachThanhTraDetails.jsx